import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function designSlider() {
	const section = document.querySelector('.design-slider');
	if (!section) return;

	const container = section.querySelector('.design-slider__slider');
	if (!container) return;

	const prevBtn = section.querySelector('.design-slider__nav--prev');
	const nextBtn = section.querySelector('.design-slider__nav--next');

	new Swiper(container, {
		modules: [Navigation, Pagination],
		slidesPerView: 'auto',
		centeredSlides: true,
		loop: true,
		speed: 500,
		//spaceBetween: 30,
		grabCursor: true,
		navigation: {
			prevEl: prevBtn,
			nextEl: nextBtn,
		},
		pagination: {
			el: '.design-slider .swiper-pagination',
			clickable: true,
		},
	});
}
